// Metrica tecnica con animazione flash al cambio valore
import { useState, useEffect, useRef } from 'react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../ui/tooltip';
import { Info } from 'lucide-react';

export function TechMetric({ label, value, unit, icon: Icon, tooltip, highlight = false }) {
  const prevValue = useRef(value);
  const [flash, setFlash] = useState(false);

  useEffect(() => {
    if (prevValue.current !== value) {
      setFlash(true);
      const timeout = setTimeout(() => setFlash(false), 500);
      prevValue.current = value;
      return () => clearTimeout(timeout);
    }
  }, [value]);

  const content = (
    <div className={`flex flex-col gap-1 transition-colors duration-300 ${flash ? 'bg-amber-50 rounded-lg p-2 -m-2' : ''}`}>
      <div className="flex items-center gap-2">
        {Icon && <Icon className="h-4 w-4 text-zinc-400" />}
        <span className="text-sm text-zinc-500 font-medium">{label}</span>
        {tooltip && (
          <Info className="h-3 w-3 text-zinc-300 cursor-help" />
        )}
      </div>
      <div className="flex items-baseline gap-1">
        <span className={`font-mono text-2xl font-bold ${highlight ? 'text-emerald-600' : 'text-zinc-900'}`}>
          {value}
        </span>
        {unit && <span className="text-sm text-zinc-500">{unit}</span>}
      </div>
    </div>
  );

  if (tooltip) {
    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <div className="cursor-help">{content}</div>
          </TooltipTrigger>
          <TooltipContent className="bg-zinc-900 text-zinc-50 text-xs px-3 py-2 rounded-lg max-w-xs">
            {tooltip}
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }

  return content;
}
